import { Component, OnInit } from '@angular/core';
import { AdminService } from '../../index';
import { Agency } from '../../model/index';
import { Router } from '@angular/router';
import { Globals } from '../../../globals';


@Component({
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.css']
})
export class AgencyComponent implements OnInit {

  agencies: Array<Agency>;

  constructor(private adminService: AdminService<Agency>, private globals: Globals,
    private router: Router) { }

  ngOnInit() {
    this.adminService.get('/api/admin/agencies')
      .subscribe(
        data => this.agencies = data,
        err => console.log(err)
      );
  }

  addAgency() {
    this.router.navigate(['/home/admin/agency/add'], { skipLocationChange: true });
  }

}
